import { z } from "zod";

export type Tenant = {
  id: string;
  shortCode: string;
};

export type User = {
  id: string;
  email: string;
  displayName: string | null;
  photoURL: string | null;
  role: string;
  tenants: Tenant[];
};

export type Role = {
  id: string;
  name: string;
};

export type UserSegment = {
  id: number;
  name: string;
};

export type JobLogLevel = "info" | "debug";

export const propertyAttributeTypes = ["title", "date", "endDate"] as const;
export type PropertyAttributeType = (typeof propertyAttributeTypes)[number];
export const zPropertyAttributeType = z.enum(propertyAttributeTypes);
